<script setup>
import API from '@/api/api-main';
import { format } from 'date-fns';
import { useToast } from 'primevue/usetoast';
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { renderStatus } from '../helper/renderStatus';

const store = useStore();
const { proxy } = getCurrentInstance();
const toast = useToast();
const addressCustomerModal = ref(false);
const visible = ref(false);
const submited = ref(false);
const isSpecialVTS = ref(false);
const loading = ref(false);
const dataCity = ref([]);
const customerData = ref({
    typeDoc: 100,
    series: '',
    bpCode: '',
    cardName: '',
    type: 'P',
    groupCode: '',
    licTradNum: '',
    citizenId: '',
    avatar: '',
    gender: 'M',
    dateOfBirth: null,
    issueDate: null, // ngày cấp giấy tờ (bổ sung)
    occupation: '', // nghề nghiệp (bổ sung)
    address: '',
    location: '',
    locationId: 0,
    locationName: '',
    area: '',
    areaId: 0,
    areaName: '',
    city: '',
    cityId: 0,
    cityName: '',
    country: '',
    email: '',
    phone: '',
    person: '',
    note: '',
    status: 'HD',
    nationality: false,
    creator: store.state.auth.user.appUser.fullName,
    isEmployee: false,
    employeeId: '',
    crD1: [],
    dshTs: [
        {
            type: 'VTS',
            accumulatedValue: 0,
            isSpecial: false
        }
    ]
});
const dataClear = JSON.stringify(customerData.value);

// Dữ liệu nạp sẵn (quét CCCD, tra mã số thuế, khách đã có) thường thiếu một số field.
// Gộp lên form mặc định để typeDoc/nationality/occupation/issueDate... không bị undefined làm hụt validate.
const mergeCustomer = (source) => ({ ...JSON.parse(dataClear), ...source });
const listArea = ref({});
const dataForm = new FormData();
const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    detailCustomer: {
        type: Object,
        default: () => null
    }
});

const emits = defineEmits(['visible', 'update:data']);

const isValidPhone = (phone) => {
    const phoneRegex = /^0\d{9,11}$/;
    return phoneRegex.test(phone);
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

/** Khách cá nhân trong nước: bắt buộc Nghề nghiệp / Quận-Huyện / Phường-Xã / Ngày cấp, kể cả khi tạo mới */
const requireExtraInfo = computed(() => customerData.value.type === 'P' && !customerData.value.nationality);

/** CCCD (typeDoc 100): bắt buộc đủ 12 ký tự sau trim */
const citizenIdInputInvalid = computed(() => {
    if (customerData.value.type !== 'P') return false;
    const v = String(customerData.value.citizenId ?? '').trim();
    if (!v) return true;
    if (customerData.value.typeDoc === 100 && v.length !== 12) return true;
    return false;
});

const Openfile = () => {
    document.querySelectorAll('.click-file')[0].click();
};
const OpenFileFront = () => {
    document.querySelectorAll('.click-file-front')[0].click();
};
const OpenFileBack = () => {
    document.querySelectorAll('.click-file-back')[0].click();
};
const UploadFileLocal = async (event, index) => {
    const file = event.target.files[0];
    dataForm.append('images', file);
    document.querySelectorAll('.click-file')[index].value = '';
    customerData.value.avatar = URL.createObjectURL(file);
};

const UploadFileFrontLocal = async (event, index) => {
    const file = event.target.files[0];
    // mỗi lần chọn lại ảnh thì xóa key cũ để tránh trùng lặp
    dataForm.delete('imageBefore');
    dataForm.append('imageBefore', file);
    document.querySelectorAll('.click-file-front')[index].value = '';
    customerData.value.imageBefore = URL.createObjectURL(file);
};

const UploadFileBackLocal = async (event, index) => {
    const file = event.target.files[0];
    // mỗi lần chọn lại ảnh thì xóa key cũ để tránh trùng lặp
    dataForm.delete('imageAfter');
    dataForm.append('imageAfter', file);
    document.querySelectorAll('.click-file-back')[index].value = '';
    customerData.value.imageAfter = URL.createObjectURL(file);
};

const clearFormDataFiles = () => {
    dataForm.delete('images');
    dataForm.delete('imageBefore');
    dataForm.delete('imageAfter');
    dataForm.delete('item');
};
const openAddDeliveryDialog = (data) => {
    addressCustomerModal.value = true;
    listArea.value = { ...data };
    if (data) {
        listArea.value.city = {
            id: data.cityId,
            name: data.cityName
        };
        listArea.value.area = {
            id: data.areaId,
            name: data.areaName
        };
        listArea.value.location = {
            id: data.locationId,
            name: data.locationName
        };
    }
};

const SaveCustomer = async () => {
    submited.value = true;
    const API_URL = customerData.value.id ? `Customer/${customerData.value.id}` : 'Customer/add';
    const FuncAPI = customerData.value.id ? API.update : API.add;
    if (validateData()) return;
    // chỉ xóa payload dữ liệu, giữ lại các file đã append trước đó
    dataForm.delete('item');
    customerData.value.creator = store.state.auth.user.appUser.fullName;
    customerData.value.type == 'P' ? delete customerData.value.licTradNum : delete customerData.value.citizenId;
    dataForm.append('item', JSON.stringify(customerData.value));
    try {
        loading.value = true;
        const res = await FuncAPI(API_URL, dataForm);
        if (res.data.id) {
            proxy.$notify('S', 'Thành công', toast);
            emits('update:data', res.data);
            closeDialog();
        } else {
            proxy.$notify('E', 'Thất bại', toast);
        }
    } catch (error) {
        proxy.$notify('E', error.response.data.errors, toast);
    } finally {
        loading.value = false;
    }
};
const closeDialog = () => {
    submited.value = false;
    // dọn các field trong FormData cho lần sử dụng tiếp theo
    clearFormDataFiles();
    customerData.value = JSON.parse(dataClear);
    visible.value = false;
};

const hideDialog = () => {
    emits('visible', false);
};

const searchAddress = async (e, dataAdd = null) => {
    try {
        if (dataAdd) {
            const { data } = await API.get(`Area/searchs/${dataAdd.id}/${e.query.trim()}`);
            dataCity.value = data;
            return;
        }
        const { data } = await API.get(`Area/searchs/${e.query.trim()}`);
        dataCity.value = data;
    } catch (error) {}
};

const setValueAdd = (item, data, name, id) => {
    if (item.value.name == undefined) return;
    data[name] = item.value.name;
    data[id] = item.value.id;
    if (name === 'cityName') data.area = '';
    if (name === 'areaName') data.location = '';
};
const valuegoldJewelry = ref();
const validateData = () => {
    const { cardName, phone, city, area, location, cityName, areaName, locationName, occupation, issueDate, citizenId, email, licTradNum, type, nationality, country, dateOfBirth, typeDoc, citizenIdExpiryDate } = customerData.value;
    if (type == 'P') {
        if (!nationality) {
            if (!cardName || !phone || !citizenId || !cityName || !dateOfBirth) {
                proxy.$notify('E', `Vui lòng nhập đủ thông tin cá nhân !`, toast);
                return true;
            }
            if (citizenId && typeDoc === 100 && !citizenIdExpiryDate) {
                proxy.$notify('W', 'Vui lòng chọn ngày hết hạn CCCD', toast);
                return true;
            }
            // Khách hàng cá nhân (Việt Nam): bắt buộc nhập đủ các trường bổ sung, cả khi tạo mới
            if (!occupation || !areaName || !locationName || !issueDate) {
                proxy.$notify('E', `Vui lòng nhập đủ thông tin bắt buộc (Nghề nghiệp, Quận/Huyện, Phường/Xã, Ngày cấp giấy tờ) !`, toast);
                return true;
            }
        } else {
            if (!cardName || !phone || !citizenId || !country || !dateOfBirth) {
                proxy.$notify('E', `Vui lòng nhập đủ thông tin cá nhân !`, toast);
                return true;
            }
        }
    } else {
        if (!cardName || !licTradNum) {
            proxy.$notify('E', `Vui lòng nhập đủ thông tin !`, toast);
            return true;
        }
    }

    if (type == 'P' && typeDoc === 100) {
        const id = String(citizenId ?? '').trim();
        if (id.length !== 12) {
            proxy.$notify('E', 'Số căn cước công dân phải đủ 12 ký tự.', toast);
            return true;
        }
    }

    // dùng !nationality (không phải == false) để nationality undefined không rơi nhầm sang nhánh bắt nhập quốc gia
    if (!nationality) {
        // if (!city || !area || !location) {
        //   proxy.$notify("E", `Vui lòng nhập địa chỉ !`, toast);
        //   return true;
        // }
        return false;
    } else {
        if (!country) {
            proxy.$notify('E', `Vui lòng nhập quốc gia !`, toast);
            return true;
        }
    }
    if (citizenId?.length > 14 && type == 'P' && !nationality) {
        proxy.$notify('E', `Số CMND phải nhỏ hơn 14 số !`, toast);
        return true;
    }

    if (citizenId?.length > 14 && type == 'P' && isNaN(citizenId) && !nationality) {
        proxy.$notify('E', `Căn cước công dân phải là số !`, toast);
        return true;
    }

    if (!isValidPhone(phone) && phone) {
        proxy.$notify('E', `Số điện thoại không hợp lệ !`, toast);
        return true;
    }

    if (email && !isValidEmail(email)) {
        proxy.$notify('E', `Email không hợp lệ !`, toast);
        return true;
    }
    return false;
};

const AddAddress = () => {
    listArea.value.submited = true;
    if (
        // !listArea.value.cityId ||
        // !listArea.value.areaId ||
        // !listArea.value.locationId ||
        !listArea.value.phone
    ) {
        proxy.$notify('E', `Vui lòng nhập đủ thông tin !`, toast);
        return;
    }

    if (!isValidPhone(listArea.value.phone)) {
        proxy.$notify('E', `Số điện thoại không hợp lệ !`, toast);
        return true;
    }

    if (listArea.value.email && !isValidEmail(listArea.value.email)) {
        proxy.$notify('E', `Email không hợp lệ !`, toast);
        return true;
    }

    if (!listArea.value.id) {
        listArea.value.status = 'A';
        if (customerData.value.crD1.length == 0) {
            listArea.value.default = 'Y';
        }
        customerData.value.crD1.push({ ...listArea.value });
    } else {
        const index = customerData.value.crD1.findIndex((e) => e.id == listArea.value.id);
        if (index != -1) {
            customerData.value.crD1[index] = { ...listArea.value };
            customerData.value.crD1[index].status = 'U';
        }
    }

    addressCustomerModal.value = false;
};

const closeAddAddress = () => {
    listArea.value = {};
    addressCustomerModal.value = false;
};

const getAddress = (data) => {
    if (!data) return '';
    return `${data.address || ''} ${checkNull(data.address)} ${data.locationName || ''} ${checkNull(data.locationName)} ${data.areaName || ''} ${checkNull(data.cityName)} ${data.cityName || ''}`;
};
const checkNull = (data) => {
    return data ? ',' : '';
};

const changeDefault = (item) => {
    customerData.value.crD1
        .filter((e) => e.status != 'D')
        .forEach((e) => {
            if (e.id != item.id) {
                e.default = 'N';
                e.status = 'U';
            }
        });
    item.default = 'Y';
    item.status = 'U';
};

const removeAddress = (item) => {
    if (item.id) {
        item.status = 'D';
    } else {
        customerData.value.crD1 = customerData.value.crD1?.filter((e) => e != item);
    }
    if (customerData.value.crD1.filter((e) => e.status != 'D').length === 1) {
        customerData.value.crD1.filter((e) => e.status != 'D')[0].default = 'Y';
    }
};

const paginator = ref({
    page: 0,
    pagesize: 10,
    total: 0,
    search: ''
});
const loadingHistory = ref(false);
const dataHistory = ref([]);

const getHistory = async () => {
    if (!customerData.value.id) return;
    try {
        loadingHistory.value = true;
        const res = await API.get(`GoodReceiptPO/cardId/${customerData.value.id}?Page=${paginator.value.page + 1}&PageSize=${paginator.value.pagesize}${paginator.value.search ? `&Filter=invoiceCode=*` + paginator.value.search : ''}`);
        paginator.value.total = res.data.total;
        dataHistory.value = res.data.item;
    } catch (error) {
    } finally {
        loadingHistory.value = false;
    }
};
const handleFilter = () => {
    paginator.value.page = 1;
    getHistory();
};

const onPage = (e) => {
    paginator.value.page = e.page;
    paginator.value.pagesize = e.rows;
    getHistory();
};

watch(
    () => customerData.value.id,
    () => {
        if (customerData.value.id) {
            getHistory();
        }
    }
);

onMounted(async () => {
    await getOptionRank();
    await getHistory();
    await addGoldJewelry();
});
//Get option rank
const optionRank = ref({
    exchange: {},
    jewelry: {}
});
const getOptionRank = async () => {
    try {
        const [resExchange, resJewelry] = await Promise.all([API.get('TTHTV/getall?Page=1&PageSize=10&Filter=(type=VTD,status=A)'), API.get('TTHTV/getall?Page=1&PageSize=10&Filter=(type=VTS,status=A)')]);
        optionRank.value.exchange = resExchange?.data?.items?.data?.find((e) => e.status == 'A') || {};
        optionRank.value.jewelry = resJewelry?.data?.items?.data?.find((e) => e.status == 'A') || {};
    } catch (error) {}
};

const renderDateEnd = (numTime = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + numTime);
    return date;
};
const changeGoldJewelry = (e) => {
    const goldJewelry = customerData.value.dshTs.find((item) => item.type === 'VTS');
    const res = optionRank.value.jewelry.ghtvTs.find((el) => el.thtId == e.value.thtId);
    if (goldJewelry) {
        goldJewelry.quantityMin = e.value.quantityMin;
        goldJewelry.quantityMax = e.value.quantityMax;
        goldJewelry.thtId = e.value.thtId;
        goldJewelry.dateEnd = renderDateEnd(res.time);
    }
};

const changeIsSpecialVTS = () => {
    let vtsItem = customerData.value.dshTs.find((item) => item.type === 'VTS');
    // Nếu không có VTS và isSpecialVTS = true thì khởi tạo mới
    if (!vtsItem && isSpecialVTS.value) {
        const res = optionRank.value?.jewelry?.nhtvTs?.length > 0 ? optionRank.value?.jewelry?.nhtvTs[0] : null;
        const ghtvTs = optionRank.value?.jewelry?.ghtvTs?.find((el) => el.thtId == res?.thtId) || {};
        const item = {
            type: 'VTS',
            accumulatedValue: 0,
            isSpecial: true,
            quantityMin: res?.quantityMin || 0,
            quantityMax: res?.quantityMax || 0,
            thtId: res?.thtId || null,
            dateEnd: renderDateEnd(ghtvTs?.time || 0)
        };
        customerData.value.dshTs.push(item);
        vtsItem = customerData.value.dshTs.find((item) => item.type === 'VTS');
    }
    if (vtsItem && vtsItem.isSpecial) {
        // Khi VTS được chọn là khách hàng ưu đãi, có thể chọn hạng thẻ
        return;
    } else if (vtsItem && !vtsItem.isSpecial) {
        // Khi VTS không phải khách hàng ưu đãi, reset về hạng thẻ mặc định
        const res = optionRank.value?.jewelry?.nhtvTs?.length > 0 ? optionRank.value?.jewelry?.nhtvTs[0] : null;
        const ghtvTs = optionRank.value?.jewelry?.ghtvTs?.find((el) => el.thtId == res?.thtId) || {};

        if (vtsItem) {
            valuegoldJewelry.value = res;
            vtsItem.quantityMin = res?.quantityMin || 0;
            vtsItem.quantityMax = res?.quantityMax || 0;
            vtsItem.thtId = res?.thtId || null;
            vtsItem.dateEnd = renderDateEnd(ghtvTs?.time || 0);
        }
    }
};

const addGoldJewelry = () => {
    const res = optionRank.value?.jewelry?.nhtvTs?.length > 0 ? optionRank.value?.jewelry?.nhtvTs[0] : null;
    const ghtvTs = optionRank.value?.jewelry?.ghtvTs?.find((el) => el.thtId == res?.thtId) || {};
    const goldJewelry = customerData.value?.dshTs?.find((item) => item.type === 'VTS') || {};
    if (goldJewelry) {
        valuegoldJewelry.value = res;
        goldJewelry.quantityMin = res?.quantityMin || 0;
        goldJewelry.quantityMax = res?.quantityMax || 0;
        goldJewelry.thtId = res?.thtId || null;
        goldJewelry.dateEnd = renderDateEnd(ghtvTs?.time || 0);
    }
};

const checkDateOfBirth = () => {
    if (!customerData.value.id && customerData.value.type == 'P') {
        return new Date(new Date().setFullYear(new Date().getFullYear() - 18));
    }
    return new Date(new Date().setFullYear(new Date().getFullYear()));
};
watch(
    () => props.visible,
    () => {
        if (props.visible) {
            // mỗi lần mở dialog thì clear các file cũ tránh gửi nhầm ảnh khách trước
            clearFormDataFiles();
            visible.value = true;
            if (props.detailCustomer?.id) {
                customerData.value = mergeCustomer(props.detailCustomer);
            }
        }
    }
);

watch(
    () => props.detailCustomer,
    () => {
        if (props.detailCustomer?.cardName) {
            customerData.value = mergeCustomer(props.detailCustomer);
            customerData.value.city = {
                id: props.detailCustomer.cityId,
                name: props.detailCustomer.cityName
            };
            customerData.value.area = {
                id: props.detailCustomer.areaId,
                name: props.detailCustomer.areaName
            };
            customerData.value.location = {
                id: props.detailCustomer.locationId,
                name: props.detailCustomer.locationName
            };
            customerData.value.dateOfBirth = props.detailCustomer.dateOfBirth ? new Date(props.detailCustomer.dateOfBirth) : '';
            customerData.value.issueDate = props.detailCustomer.issueDate ? new Date(props.detailCustomer.issueDate) : '';
            customerData.value.citizenIdExpiryDate = props.detailCustomer.citizenIdExpiryDate ? new Date(props.detailCustomer.citizenIdExpiryDate) : '';
        } else {
            customerData.value = JSON.parse(dataClear);
            addGoldJewelry();
        }
    }
);
const renderName = (data) => {
    switch (data) {
        case 13:
            return 'Phiếu bán hàng';
        case 67:
            return 'Điều chuyển kho';
        case 20:
            return 'Nhập kho';
        case 18:
            return 'Phiếu mua hàng';
        case 26:
            return 'Phiếu đặt hàng';
        case 19:
            return 'Đổi trả hàng';
        case 27:
            return 'Xuất khác';
        default:
            return '---';
    }
};

const formatNumber = (number) => {
    if (typeof number !== 'number' || isNaN(number)) {
        return 0;
    }
    return number.toLocaleString('vi-VN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

const customerDocs = [
    { code: 100, name: 'Căn cước công dân' },
    { code: 101, name: 'Chứng minh nhân dân' },
    { code: 102, name: 'Định danh cá nhân' },
    { code: 103, name: 'Hộ chiếu' },
    { code: 104, name: 'Giấy Chứng minh sỹ quan quân đội nhân dân' },
    { code: 105, name: 'Giấy CMND của Quân nhân chuyên nghiệp' },
    { code: 106, name: 'Giấy chứng minh CAND' },
    { code: 199, name: 'Giấy tờ khác (dành cho khách hàng không có quốc tịch)' },
    { code: 200, name: 'Mã số thuế' },
    { code: 201, name: 'Mã số doanh nghiệp' },
    { code: 202, name: 'Giấy phép/quyết định thành lập' }
];
</script>
<template>
    <Dialog @hide="hideDialog" position="top" :draggable="false" v-model:visible="visible" modal :header="customerData.bpCode ? `Khách hàng ${customerData.bpCode}` : `Khách hàng`" :style="{ width: '75%' }">
        <TabView>
            <TabPanel header="Thông tin">
                <div class="grid">
                    <div class="col-2 flex flex-column gap-4 justify-content-start align-items-center">
                        <div class="box-upload-img">
                            <img
                                style="width: 90px; height: 90px; object-fit: cover"
                                class="border-circle"
                                :src="customerData.avatar ? customerData.avatar : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROu4m_EZfWX487aV5yPF7LbaW7x42UKRji3A&s'"
                                alt=""
                                @click="Openfile(index)"
                            />
                        </div>
                        <Button label="Chọn ảnh" icon="pi pi-cloud-upload" class="text-white btn-up-file" raised @click="Openfile(index)" />

                        <input type="file" class="hidden click-file" @change="UploadFileLocal($event, 0)" />

                        <div class="flex flex-column align-items-center gap-3">
                            <div>
                                <Image preview :src="customerData.imageBefore ? customerData.imageBefore : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROu4m_EZfWX487aV5yPF7LbaW7x42UKRji3A&s'" width="100" class="" alt="" />
                            </div>
                            <Button label="Chọn ảnh mặt trước" icon="pi pi-cloud-upload" class="text-white btn-up-file" raised @click="OpenFileFront(index)" />

                            <input type="file" class="hidden click-file-front" @change="UploadFileFrontLocal($event, 0)" />
                        </div>

                        <div class="flex flex-column align-items-center gap-3">
                            <div>
                                <Image :src="customerData.imageAfter ? customerData.imageAfter : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROu4m_EZfWX487aV5yPF7LbaW7x42UKRji3A&s'" width="100" class="" alt="" preview />
                            </div>
                            <Button label="Chọn ảnh mặt sau" icon="pi pi-cloud-upload" class="text-white btn-up-file" raised @click="OpenFileBack(index)" />

                            <input type="file" class="hidden click-file-back" @change="UploadFileBackLocal($event, 0)" />
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="flex flex-column gap-2">
                            <div class="flex flex-column gap-2 w-12">
                                <label class="text-base font-medium text-gray-700">Mã khách hàng </label>
                                <InputText placeholder="Sinh tự động" disabled class="w-full" v-model="customerData.bpCode"> </InputText>
                            </div>
                            <label class="text-base font-medium text-gray-700">Tên khách hàng <sup class="p-important text-red-500">*</sup></label>
                            <InputText :invalid="submited && !customerData.cardName" class="w-full" v-model="customerData.cardName"> </InputText>
                        </div>
                        <div v-if="customerData.type == 'P'" class="flex flex-column my-2 gap-2">
                            <label class="text-base font-medium text-gray-700">Số điện thoại<sup class="p-important text-red-500">*</sup></label>
                            <InputText :invalid="(submited && customerData.phone.length != 11) || customerData.phone ? !isValidPhone(customerData.phone) : false" class="w-full" v-model="customerData.phone" maxlength="11"> </InputText>
                        </div>
                        <div v-else class="flex flex-column my-2 gap-2">
                            <label class="text-base font-medium text-gray-700">Số điện thoại liên hệ</label>
                            <InputText maxlength="11" class="w-full" v-model="customerData.phone" :invalid="customerData.phone ? !isValidPhone(customerData.phone) : false"> </InputText>
                        </div>
                        <div v-if="customerData.type == 'P'" class="flex flex-column my-2 gap-2">
                            <label class="text-base font-medium text-gray-700">Nghề nghiệp <sup v-if="requireExtraInfo" class="p-important text-red-500">*</sup></label>
                            <InputText :invalid="submited && requireExtraInfo && !customerData.occupation" class="w-full" v-model="customerData.occupation"> </InputText>
                        </div>
                        <div v-if="customerData.nationality != true">
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">Tỉnh/Thành phố <sup class="p-important text-red-500"></sup></label>
                                <InputText :invalid="submited && !customerData.cityName" placeholder="Chọn Tỉnh/Thành phố" class="w-full" v-model="customerData.cityName"> </InputText>
                                <!-- <AutoComplete placeholder="Chọn Tỉnh/Thành phố" optionLabel="name" v-model="customerData.city"
                  :suggestions="dataCity" @complete="searchAddress($event)"
                  @change="setValueAdd($event, customerData, 'cityName', 'cityId')"
                  :invalid="!customerData.city && submited">
                </AutoComplete> -->
                            </div>
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">Quận/Huyện <sup v-if="requireExtraInfo" class="p-important text-red-500">*</sup></label>
                                <InputText :invalid="submited && requireExtraInfo && !customerData.areaName" placeholder="Chọn Quận/Huyện" class="w-full" v-model="customerData.areaName"> </InputText>
                                <!-- <AutoComplete placeholder="Chọn Quận/Huyện" optionLabel="name" v-model="customerData.area"
                  :suggestions="dataCity" :disabled="typeof customerData.city == 'string'"
                  @change="setValueAdd($event, customerData, 'areaName', 'areaId')"
                  @complete="searchAddress($event, customerData.city)" :invalid="!customerData.area && submited">
                </AutoComplete> -->
                            </div>
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">Phường/Xã <sup v-if="requireExtraInfo" class="p-important text-red-500">*</sup></label>
                                <InputText :invalid="submited && requireExtraInfo && !customerData.locationName" placeholder="Chọn Phường/Xã" class="w-full" v-model="customerData.locationName"> </InputText>
                                <!-- <AutoComplete placeholder="Chọn Phường/Xã" optionLabel="name" v-model="customerData.location"
                  :suggestions="dataCity" @change="setValueAdd($event, customerData, 'locationName', 'locationId')"
                  @complete="searchAddress($event, customerData.area)" :disabled="typeof customerData.area == 'string'"
                  :invalid="!customerData.location && submited">
                </AutoComplete> -->
                            </div>
                        </div>
                        <div class="flex flex-column my-2 gap-2" v-else>
                            <label class="text-base font-medium text-gray-700">Quốc gia <sup class="p-important text-red-500">*</sup></label>
                            <InputText placeholder="Nhập tên quốc gia" class="w-full" v-model="customerData.country" :invalid="!customerData.country && submited"></InputText>
                        </div>

                        <div class="flex flex-column my-2 gap-2">
                            <label class="text-base font-medium text-gray-700">Địa chỉ cụ thể</label>
                            <InputText placeholder="Nhập địa chỉ" class="w-full" v-model="customerData.address"></InputText>
                        </div>
                        <div>
                            <label class="text-base font-medium text-gray-700">Địa chỉ khác</label>
                        </div>
                        <div class="py-2 px-1">
                            <div class="flex flex-column gap-2">
                                <div class="flex justify-content-between align-items-center" v-for="(item, index) in customerData.crD1?.filter((e) => e.status != 'D')" :key="item">
                                    <small class="m-0">
                                        <RadioButton class="mr-2" v-model="item.default" @change="changeDefault(item)" value="Y" name="defaultCustomer"></RadioButton>
                                        <strong>Địa chỉ {{ index + 1 }}:</strong> {{ getAddress(item) }}
                                    </small>
                                    <div class="flex">
                                        <Button icon="pi pi-pencil" size="small" text @click="openAddDeliveryDialog(item)"></Button>
                                        <Button text size="small" icon="pi pi-trash" severity="danger" @click="removeAddress(item)"></Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-column mt-5 gap-2">
                            <Button label="Thêm địa chỉ" text outlined severity="secondary" @click="openAddDeliveryDialog()" />
                        </div>
                    </div>

                    <div class="col-5">
                        <div class="flex flex-column gap-2 mb-1">
                            <label class="text-base font-medium text-gray-700 mb-2">Loại khách </label>
                            <div class="flex gap-4 mb-3 align-items-center">
                                <div class="flex align-items-center">
                                    <RadioButton v-model="customerData.type" value="P" />
                                    <label class="ml-2">Cá nhân</label>
                                </div>
                                <div class="flex align-items-center" v-if="customerData.type == 'P'">
                                    <Checkbox v-model="customerData.isEmployee" :binary="true" inputId="isEmployee" :disabled="customerData.employeeId != ''" />
                                    <label for="isEmployee" class="ml-2">CBCNV</label>
                                </div>
                                <div class="flex align-items-center">
                                    <RadioButton v-model="customerData.type" value="C" />
                                    <label class="ml-2">Công ty</label>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-column gap-2 mb-2">
                            <label class="text-base font-medium text-gray-700 mb-2">Quốc tịch </label>
                            <div class="flex gap-4 mb-3 align-items-center">
                                <div class="flex align-items-center">
                                    <RadioButton v-model="customerData.nationality" :value="false" />
                                    <label class="ml-2">Việt Nam</label>
                                </div>
                                <div class="flex align-items-center">
                                    <RadioButton v-model="customerData.nationality" :value="true" />
                                    <label class="ml-2">Nước ngoài</label>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-column gap-2" v-if="customerData.type == 'P'">
                            <label class="text-base font-medium text-gray-700">CBNV giới thiệu</label>
                            <InputText v-model="customerData.employeeId" class="w-full" placeholder="Nhập mã nhân viên" :disabled="customerData.isEmployee"></InputText>
                        </div>
                        <div>
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">
                                    {{ customerData.type == 'P' ? 'Ngày sinh' : 'Ngày thành lập' }}
                                    <sup class="p-important text-red-500">*</sup></label
                                >
                                <div class="flex gap-2">
                                    <Calendar class="w-full" showIcon iconDisplay="input" :maxDate="checkDateOfBirth()" v-model="customerData.dateOfBirth" dateFormat="dd/mm/yy" :invalid="submited && !customerData.dateOfBirth" />
                                    <div class="flex gap-2" v-if="customerData.type == 'P'">
                                        <div class="flex align-items-center">
                                            <RadioButton name="Nam" v-model="customerData.gender" value="M" />
                                            <label class="ml-2">Nam</label>
                                        </div>
                                        <div class="flex align-items-center">
                                            <RadioButton name="Nữ" v-model="customerData.gender" value="F" />
                                            <label class="ml-2">Nữ</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-column gap-2">
                                <label class="text-base font-medium text-gray-700">Loại giấy tờ<sup class="p-important text-red-500">*</sup></label>
                                <Dropdown class="w-full" v-model="customerData.typeDoc" :options="customerDocs" optionLabel="name" optionValue="code" placeholder="Chọn loại giấy tờ" />

                                <div v-if="customerData.type == 'P'" class="flex flex-column my-2 gap-2">
                                    <label class="text-base font-medium text-gray-700">Căn cước công dân / Hộ chiếu<sup class="p-important text-red-500">*</sup></label>
                                    <InputText class="w-full" maxlength="12" v-model="customerData.citizenId" :invalid="submited && citizenIdInputInvalid"></InputText>
                                </div>
                                <div v-if="customerData.type == 'P'" class="flex flex-column gap-2">
                                    <label class="text-base font-medium text-gray-700">Ngày hết hạn CCCD<sup class="p-important text-red-500">*</sup></label>
                                    <Calendar class="w-full" dateFormat="dd/mm/yy" showIcon iconDisplay="input" v-model="customerData.citizenIdExpiryDate" :invalid="submited && !customerData.citizenIdExpiryDate"></Calendar>
                                </div>
                                <div v-else class="flex flex-column my-2 gap-2">
                                    <label class="text-base font-medium text-gray-700"
                                        >Mã số thuế
                                        <sup class="p-important text-red-500">*</sup>
                                    </label>
                                    <InputText class="w-full" v-model="customerData.licTradNum" maxlength="14"></InputText>
                                </div>
                            </div>
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">Ngày cấp giấy tờ <sup v-if="requireExtraInfo" class="p-important text-red-500">*</sup></label>
                                <Calendar class="w-full" showIcon iconDisplay="input" v-model="customerData.issueDate" dateFormat="dd/mm/yy" :invalid="submited && requireExtraInfo && !customerData.issueDate" />
                            </div>
                            <div class="flex flex-column my-2 gap-2">
                                <label class="text-base font-medium text-gray-700">Email</label>
                                <InputText class="w-full" v-model="customerData.email" :invalid="customerData.email ? !isValidEmail(customerData.email) : false"></InputText>
                            </div>
                            <!-- Header -->
                            <div class="mb-3">
                                <b class="text-lg">Hạng thẻ khách hàng</b>
                            </div>

                            <!-- Layout ngang cho 2 thẻ -->
                            <div class="flex gap-3">
                                <!-- Thẻ Vàng trao đổi -->
                                <div class="flex-1">
                                    <div class="p-3 border-round-xl shadow-2 font-medium text-black-alpha-90" style="background-color: rgba(255, 243, 224, 1); border: 2px solid #f59e0b">
                                        <!-- Header thẻ với checkbox -->
                                        <div class="flex justify-content-between align-items-center mb-2">
                                            <div class="flex align-items-center">
                                                <i class="pi pi-star-fill text-yellow-500 mr-2"></i>
                                                <b class="text-base">Vàng trao đổi</b>
                                            </div>
                                            <div class="flex align-items-center">
                                                <label class="mr-2 text-sm">KH ưu đãi</label>
                                                <Checkbox :disabled="true" :binary="true" />
                                            </div>
                                        </div>

                                        <!-- Hạng hiện tại -->
                                        <div class="mb-2">
                                            <div class="text-center">
                                                <div class="inline-flex align-items-center p-1 px-2 border-2 border-yellow-500 border-round-lg bg-white">
                                                    <span class="text-sm font-semibold">Hạng hiện tại</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Giá trị giới hạn -->
                                        <div class="mb-2">
                                            <div class="text-center mb-1">
                                                <span class="text-sm font-semibold">Giá trị giới hạn</span>
                                            </div>
                                            <div class="text-center">
                                                <span class="text-sm">
                                                    {{ customerData?.dshTs?.find((e) => e.type == 'VTD')?.quantityMin >= 0 ? '(' + customerData?.dshTs?.find((e) => e.type == 'VTD')?.quantityMin : '(0' }}
                                                    <i class="pi pi-arrow-right text-xs mx-1"></i>
                                                    {{ customerData?.dshTs?.find((e) => e.type == 'VTD')?.quantityMax ? formatNumber(customerData?.dshTs?.find((e) => e.type == 'VTD')?.quantityMax) + ' chỉ)' : '∞ chỉ)' }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Giá trị tích lũy -->
                                        <div class="mb-2">
                                            <div class="text-center mb-1">
                                                <span class="text-sm font-semibold">Giá trị tích lũy</span>
                                            </div>
                                            <div class="text-center">
                                                <b class="text-xl text-red-600">
                                                    {{ formatNumber(customerData?.dshTs?.find((e) => e.type == 'VTD')?.accumulatedValue || 0) }}
                                                    CHỈ
                                                </b>
                                            </div>
                                        </div>

                                        <!-- Thời gian -->
                                        <div class="text-center">
                                            <div class="mb-1">
                                                <span class="text-sm font-semibold">Thời gian đến</span>
                                            </div>
                                            <span class="text-sm">--</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Thẻ Vàng trang sức -->
                                <div class="flex-1 w-6">
                                    <div class="p-3 border-round-xl shadow-2 font-medium text-black-alpha-90" style="background-color: rgba(219, 248, 237, 1); border: 2px solid #10b981">
                                        <!-- Header thẻ với checkbox -->
                                        <div class="flex justify-content-between align-items-center mb-2">
                                            <div class="flex align-items-center">
                                                <i class="pi pi-box text-green-500 mr-2"></i>
                                                <b class="text-base">Vàng trang sức</b>
                                            </div>
                                            <div class="flex align-items-center">
                                                <label class="mr-2 text-sm" for="isSpecialVTS">KH ưu đãi</label>
                                                <Checkbox
                                                    v-if="!customerData.id && customerData.dshTs && customerData.dshTs.length > 0"
                                                    v-model="customerData.dshTs.find((e) => e.type == 'VTS')['isSpecial']"
                                                    :binary="true"
                                                    @change="changeIsSpecialVTS"
                                                    inputId="isSpecialVTS"
                                                />
                                                <Checkbox v-else-if="!customerData.id" v-model="isSpecialVTS" :binary="true" @change="changeIsSpecialVTS" inputId="isSpecialVTS" />
                                                <Checkbox
                                                    v-if="customerData.id && customerData.dshTs && customerData.dshTs.length > 0"
                                                    :disabled="customerData.id"
                                                    :checked="customerData.dshTs.find((e) => e.type == 'VTS')?.isSpecial"
                                                    :binary="true"
                                                />
                                            </div>
                                        </div>

                                        <!-- Hạng hiện tại/Dropdown -->
                                        <div class="mb-2">
                                            <div v-if="customerData.id" class="text-center">
                                                <div class="inline-flex align-items-center p-1 px-2 border-2 border-green-500 border-round-lg bg-white">
                                                    <span class="text-md font-semibold">{{ customerData?.dshTs?.find((e) => e.type == 'VTS')?.tht?.name || 'Chưa có hạng' }}</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <Dropdown
                                                    :disabled="!customerData.dshTs.find((e) => e.type == 'VTS')?.isSpecial"
                                                    @change="changeGoldJewelry"
                                                    v-model="valuegoldJewelry"
                                                    :options="optionRank?.jewelry?.nhtvTs || []"
                                                    optionLabel="tht.name"
                                                    placeholder="Chọn hạng thẻ"
                                                    class="w-full text-md"
                                                />
                                            </div>
                                        </div>

                                        <!-- Giá trị giới hạn -->
                                        <div class="mb-2">
                                            <div class="text-center mb-1">
                                                <span class="text-sm font-semibold">Giá trị giới hạn</span>
                                            </div>
                                            <div class="text-center">
                                                <span class="text-sm">
                                                    {{ customerData?.dshTs?.find((e) => e.type == 'VTS')?.quantityMin >= 0 ? '(' + formatNumber(customerData?.dshTs?.find((e) => e.type == 'VTS')?.quantityMin) : '(0' }}
                                                    <i class="pi pi-arrow-right text-xs mx-1"></i>
                                                    {{ customerData?.dshTs?.find((e) => e.type == 'VTS')?.quantityMax ? formatNumber(customerData?.dshTs?.find((e) => e.type == 'VTS')?.quantityMax) + ' Tr)' : '∞ Tr)' }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Giá trị tích lũy -->
                                        <div class="mb-2">
                                            <div class="text-center mb-1">
                                                <span class="text-sm font-semibold">Giá trị tích lũy</span>
                                            </div>
                                            <div class="text-center">
                                                <b class="text-xl text-red-600">
                                                    {{ formatNumber(customerData?.dshTs?.find((e) => e.type == 'VTS')?.accumulatedValue || 0) }}
                                                    VND
                                                </b>
                                            </div>
                                        </div>

                                        <!-- Thời gian đến -->
                                        <div class="text-center">
                                            <div class="mb-1">
                                                <span class="text-sm font-semibold">Thời gian đến</span>
                                            </div>
                                            <span class="text-sm">
                                                {{ customerData?.dshTs?.find((e) => e.type == 'VTS')?.dateEnd ? format(customerData?.dshTs?.find((e) => e.type == 'VTS')?.dateEnd || new Date(), 'dd/MM/yyyy') : '--' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Lịch sử">
                <DataTable showGridlines stripedRows :value="dataHistory" paginator lazy :rows="paginator.pagesize" :rowsPerPageOptions="[10, 20, 50, 100, 200, 500]" :page="paginator.page" :totalRecords="paginator.total" @page="onPage($event)">
                    <template #header>
                        <div class="flex justify-content-end">
                            <IconField iconPosition="left">
                                <InputIcon>
                                    <i class="pi pi-search" />
                                </InputIcon>
                                <InputText v-model="paginator.search" placeholder="Tìm kiếm mã nghiệp vụ" @change="handleFilter" />
                            </IconField>
                        </div>
                    </template>
                    <template #empty>
                        <div class="p-2 text-center">Không tìm thấy lịch sử giao dịch</div>
                    </template>
                    <Column field="invoiceCode" header="Mã nghiệp vụ"></Column>
                    <Column header="Tên nghiệp vụ">
                        <template #body="slotProps">
                            {{ renderName(slotProps.data.objType) }}
                        </template>
                    </Column>
                    <Column field="creator" header="Người tạo"></Column>
                    <Column field="counter.name" header="Mã quầy"></Column>
                    <Column field="branch.branchName" header="Cửa hàng"> </Column>
                    <Column field="total" header="Tổng tiền">
                        <template #body="slotProps"> {{ formatNumber(slotProps.data.total || 0) }} VNĐ </template>
                    </Column>
                    <Column field="dueDate" header="Thời gian">
                        <template #body="slotProps">
                            {{ slotProps.data.dueDate ? format(slotProps.data.dueDate, 'dd/MM/yyyy HH:mm:ss') : '--' }}
                        </template>
                    </Column>
                    <Column field="status" header="Tình trạng">
                        <template #body="{ data }">
                            {{ renderStatus(data) }}
                        </template>
                    </Column>
                </DataTable>
            </TabPanel>
        </TabView>

        <template #footer>
            <div class="flex justify-content-end gap-2 pt-3">
                <Button label="Bỏ qua" @click="closeDialog()" outlined></Button>
                <Button label="Lưu" @click="SaveCustomer"></Button>
            </div>
        </template>
    </Dialog>
    <Dialog position="top" :draggable="false" v-model:visible="addressCustomerModal" modal :header="listArea.id ? 'Cập nhật địa chỉ' : 'Thêm mới địa chỉ'" :style="{ width: '650px' }">
        <div class="card">
            <div></div>
            <div>
                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Số điện thoại <sup class="p-important text-red-500">*</sup></label>
                    <InputText class="w-full" maxlength="10" v-model="listArea.phone" :invalid="!listArea.phone && listArea.submited"></InputText>
                </div>
                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Email</label>
                    <InputText class="w-full" type="email" v-model="listArea.email" :invalid="listArea.email && !isValidEmail(listArea.email) && listArea.submited"></InputText>
                </div>

                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Tỉnh/Thành phố </label>
                    <AutoComplete
                        placeholder="Chọn Tỉnh/Thành phố"
                        optionLabel="name"
                        v-model="listArea.city"
                        :suggestions="dataCity"
                        @complete="searchAddress($event)"
                        @change="setValueAdd($event, listArea, 'cityName', 'cityId')"
                        :invalid="!listArea.city && listArea.submited"
                    >
                    </AutoComplete>
                </div>
                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Quận/Huyện </label>
                    <AutoComplete
                        placeholder="Chọn Quận/Huyện"
                        optionLabel="name"
                        v-model="listArea.area"
                        :suggestions="dataCity"
                        :disabled="!listArea.cityId"
                        @change="setValueAdd($event, listArea, 'areaName', 'areaId')"
                        @complete="searchAddress($event, listArea.city)"
                        :invalid="!listArea.area && listArea.submited"
                    >
                    </AutoComplete>
                </div>
                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Phường/Xã </label>
                    <AutoComplete
                        placeholder="Chọn Phường/Xã"
                        optionLabel="name"
                        v-model="listArea.location"
                        :suggestions="dataCity"
                        @change="setValueAdd($event, listArea, 'locationName', 'locationId')"
                        @complete="searchAddress($event, listArea.area)"
                        :disabled="!listArea.areaId"
                        :invalid="!listArea.location && listArea.submited"
                    >
                    </AutoComplete>
                </div>

                <div class="flex flex-column my-2 gap-2">
                    <label class="text-base font-medium text-gray-700">Địa chỉ</label>
                    <InputText class="w-full" v-model="listArea.address"></InputText>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="flex justify-content-end gap-2 pt-3">
                <Button label="Đóng" @click="closeAddAddress()" outlined></Button>
                <Button label="Lưu" @click="AddAddress()"></Button>
            </div>
        </template>
    </Dialog>
</template>
<style scoped>
.box-upload-img {
    border: 1px solid;
    border-radius: 50%;
    border-style: dashed;
}

.box-upload-img:hover .btn-up-file {
    display: block;
}

.sticky-table {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 10px;
}
</style>
